import { ref, computed } from 'vue'

export function usePdfZoom() {
  const scale = ref(1)
  const MIN = 0.5
  const MAX = 3
  const STEP = 0.25

  const canZoomIn = computed(() => scale.value < MAX)
  const canZoomOut = computed(() => scale.value > MIN)
  const scalePercentage = computed(() => Math.round(scale.value * 100))

  const zoomIn = () => {
    if (canZoomIn.value) scale.value += STEP
  }

  const zoomOut = () => {
    if (canZoomOut.value) scale.value -= STEP
  }

  const resetZoom = () => (scale.value = 1)

  return {
    scale,
    canZoomIn,
    canZoomOut,
    scalePercentage,
    zoomIn,
    zoomOut,
    resetZoom,
  }
}
